import React, { useEffect, useState } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
    Typography, Drawer, Toolbar, AppBar, IconButton, Theme, CssBaseline, Box, Button, Tooltip
} from '@material-ui/core'
import { TreeItem, TreeItemProps, TreeView } from '@material-ui/lab';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
    Settings as SettingsIcon,
    People as PeopleIcon,
    Email as EmailIcon,
    SettingsApplications as SettingsApplicationsIcon,
    Payment as PaymentIcon,
    Edit as EditIcon,
    MergeType as MergeTypeIcon,
    ArrowDropDown as ArrowDropDownIcon,
    ArrowRight as ArrowRightIcon,
    AccountCircle as AccountCircleIcon,
    EventAvailable as EventAvailableIcon,
    LocalAtm as LocalAtmIcon,
    AttachMoney as AttachMoneyIcon,
    Check,
    ChromeReaderMode
} from '@material-ui/icons'
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
import history from '../services/history.service'
import LoginApi from '../services/login.service'
import SelectCompany from '../components/SelectCompany'
import { THEME } from '../common/theme'
import { FEATURES } from '../common/constants';
import * as Icons from "@mui/icons-material";
import { SvgIconComponent } from "@mui/icons-material";
import { CHECK_VALUE } from '../common/data-validator';

const DefaultIcon: SvgIconComponent = Icons.Business;

type FeatureKey = keyof typeof FEATURES;

declare module 'csstype' {
    interface Properties {
        '--tree-view-color'?: string;
        '--tree-view-bg-color'?: string;
    }
}

type StyledTreeItemProps = TreeItemProps & {
    bgColor?: string;
    color?: string;
    labelIcon: React.ElementType;
    labelInfo?: string;
    labelText: string;
};




const useTreeItemStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            color: THEME.palette.primary.main,
            '&:hover > $content': {
                backgroundColor: THEME.palette.primary.dark,
            },
            '&:focus > $content, &$selected > $content': {
                backgroundColor: `var(--tree-view-bg-color, ${THEME.palette.primary.dark})`,
                color: 'var(--tree-view-color)',
            },
            '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
                backgroundColor: 'transparent',
            },
        },
        content: {
            color: THEME.palette.primary.contrastText,
            borderTopRightRadius: theme.spacing(2),
            borderBottomRightRadius: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1)
        },
        group: {
            marginLeft: 0,
            '& $content': {
                paddingLeft: theme.spacing(2),
            },
        },
        expanded: {},
        selected: {},
        label: {
            fontWeight: 'inherit',
            color: 'inherit',
        },
        labelRoot: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(1, 0),
        },
        labelIcon: {
            marginRight: theme.spacing(1),
            color: THEME.palette.secondary.main
        },
        labelText: {
            fontWeight: 'inherit',
            flexGrow: 1,
        },
    }),
);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
        },
        tree: {
            // height: 900,
            flexGrow: 1,
            maxWidth: 400,
        },

        drawerContainer: {
            overflow: 'auto',
            marginTop: theme.spacing(2),
            backgroundColor: THEME.palette.primary.main,
            color: THEME.palette.primary.contrastText
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(1.5),
        },
    }),
);

function StyledTreeItem(props: StyledTreeItemProps) {
   
    const classes = useTreeItemStyles();
    const { labelText, labelIcon: LabelIcon,
        labelInfo, color, bgColor, ...other } = props;
    return (
        <TreeItem
            label={
                <div className={classes.labelRoot}>
                    <LabelIcon
                        color="inherit"
                        className={classes.labelIcon}
                    />
                    <Typography
                        variant="body2"
                        className={classes.labelText}>
                        {labelText}
                    </Typography>
                    {labelInfo && (
                        <span style={{
                            backgroundColor: THEME.palette.secondary.main,
                            color: '#fff',
                            borderRadius: 10,
                            padding: '2px 5px',
                            fontSize: 9,
                            fontWeight: 700,
                            letterSpacing: 0.5,
                            marginLeft: 6,
                            lineHeight: 1.4,
                        }}>
                            {labelInfo}
                        </span>
                    )}
                </div>
            }
            classes={{
                root: classes.root,
                content: classes.content,
                expanded: classes.expanded,
                selected: classes.selected,
                group: classes.group,
            }}
            {...other}
        />
    );
}

function SRCards() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [accessibleFeatures, setAccessibleFeatures] = useState<FeatureKey[]>([])
    useEffect(() => {
        const features = localStorage.getItem('userAccessibleFeatures') || '[]';
        if (CHECK_VALUE(features)) {
            setAccessibleFeatures(JSON.parse(features));
        }
    }, []);
    const open = Boolean(anchorEl);
    const handleClick = (event:any) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
        history.push('/activity');
      };
    const classes = useStyles();
    const _service = new LoginApi();
    const userName = localStorage.getItem('email') || '';
    const name = localStorage.getItem('name') || '';
    const role = localStorage.getItem('role')?.toLowerCase() || '';
    const onLogout = () => {
        _service.logout()
			.then(function(){
                localStorage.clear();
            }).then(data => {
                window.location.reload();
            }).catch(error => {
                console.log(`error clearing cache`, error);
                window.location.reload();
            })
    }

    return (
        <Box className={classes.root}>
            <CssBaseline />
            <AppBar>
                <Toolbar>
                    <IconButton edge="start">
                        <SettingsIcon fontSize="large" />
                    </IconButton>
                    <Typography variant="h6" className={classes.content}>
                        Service Request Portal
                    </Typography>
                    {/* <Box className={classes.content}>
                       <SelectCompany />
                    </Box>  */}
                    <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                    onClick={handleClick}>
                           <MoreVertIcon/>
                        </IconButton>
                        <Menu
                           id="long-menu"
                           MenuListProps={{
                              'aria-labelledby': 'long-button',
                             }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{
                            style: {
                               maxHeight: 48 * 4.5,
                               width: '20ch',
                            },
                            }}
                        >
                             <MenuItem key='activity' onClick={handleClose}>
                                  Activity
                             </MenuItem>
                        </Menu>
                    <Tooltip
                        title={
                            <React.Fragment>
                                <Typography>
                                    {`User name - ${name}`}
                                </Typography>
                                <Typography>
                                    {`Email Id - ${userName}`}
                                </Typography>
                            </React.Fragment>
                        }>
                        <IconButton>
                            <AccountCircleIcon />
                        </IconButton>
                    </Tooltip>
                    <Button color="inherit" onClick={onLogout}>Logout</Button>
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent">
                <Toolbar />
                <Box className={classes.drawerContainer}>
                    <TreeView
                        className={classes.tree}
                        defaultExpanded={['3']}
                        defaultCollapseIcon={<ArrowDropDownIcon />}
                        defaultExpandIcon={<ArrowRightIcon />}
                        defaultEndIcon={<div style={{ width: 24 }} />}
                    >
                        {/* <StyledTreeItem
                            nodeId="1"
                            labelText="Customer"
                            labelIcon={PeopleIcon}
                            onClick={() => {
                                history.push('/customers')
                            }}
                        >
                            <StyledTreeItem
                                nodeId="2"
                                labelText="Edit"
                                labelIcon={EditIcon}
                                onClick={() => {
                                    history.push('/customers/edit')
                                }}
                            />
                            <StyledTreeItem
                                nodeId="3"
                                labelText="Merge"
                                labelIcon={MergeTypeIcon}
                                onClick={() => {
                                    history.push('/customers/merge')
                                }}
                            />
                        </StyledTreeItem> */}
                        
                        {accessibleFeatures.map((ele) => {
                            const feature = FEATURES[ele];
                            if (!feature) return null;
                            const IconComponent: SvgIconComponent = (Icons as Record<string, SvgIconComponent>)[feature.icon] || DefaultIcon;
                            return (
                                <StyledTreeItem
                                    key={ele}
                                    nodeId={ele}
                                    labelText={feature.label}
                                    labelIcon={IconComponent}
                                    labelInfo={(feature as any).isNew ? 'NEW' : undefined}
                                    onClick={() => history.push(`/${feature.route}`)}
                                />
                            );
                        })}
                        {/* <StyledTreeItem
                            nodeId="9"
                            labelText="Payment"
                            labelIcon={PaymentIcon}
                            onClick={() => {
                                history.push('/payment')
                            }}
                        /> */}
                    </TreeView>
                </Box>
            </Drawer>
            <Box className={classes.content}>
                <Toolbar />
            </Box>
        </Box>
    )

}

export default SRCards;